// extracted by mini-css-extract-plugin
module.exports = {"container":"PreviewLessons_container__Zv6_V","loading-container":"PreviewLessons_loading-container__2QAO7"};